module.exports = window["MaterialUI"].Tabs;